import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { ROUTER_PATHS } from '@/lib/constants'
import { format, STANDARD_DATE_TIME_FORMAT } from '@eigtech/ui-shared-dates'
import { Heading, Page } from '@eigtech/ui-shared-dave'
import { UploadMeetingScreenshots } from '@eigtech/ui-shared-meetings'
import { LinkButton } from '@eigtech/ui-shared-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
)({
  component: ClaimDetailMeetingUpload,
})

function ClaimDetailMeetingUpload() {
  const { claimNumber, meetingId, meetingStartTime } = Route.useParams()

  return (
    <Page
      aboveHeader={
        <LinkButton
          params={{ claimNumber, meetingStartTime, meetingId }}
          size="sm"
          to={ROUTER_PATHS.claimDetailMeeting.route}
          variant="outline"
        >
          ← Meeting Info
        </LinkButton>
      }
      heading={
        <Heading as="h2" size="md">
          {format(new Date(meetingStartTime), STANDARD_DATE_TIME_FORMAT)}
        </Heading>
      }
    >
      <UploadMeetingScreenshots
        cohort="estimator"
        entityId={ensureClaimCorn(claimNumber)}
        meetingId={meetingId}
      />
    </Page>
  )
}
